var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.17 35.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.3,1H6.88A5.88,5.88,0,0,0,1,6.88V23a5.88,5.88,0,0,0,5.88,5.88h6.47l4.79,5.77,4.71-5.77H29.3A5.87,5.87,0,0,0,35.17,23V6.88A5.87,5.87,0,0,0,29.3,1Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.78,
    y1: 12.24,
    x2: 26.39,
    y2: 12.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.27,
    y1: 19.59,
    x2: 21.9,
    y2: 19.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ea88e4dbd9ccdab0b1671b8bd32408bf.svg";
export { ForwardRef as ReactComponent };